import cx from "classnames";

export type TagPropType = {
  value?: string;
  destination?: string;
  id?: string;
  refMedium?: string;
};

export default function Tags({
  value,
  destination,
  id,
  refMedium,
}: TagPropType) {
  if (destination && refMedium) {
    destination = `${destination}?ref=${refMedium}`;
  }
  return (
    <span
      data-testid={id}
      className={cx(
        "text-nowrap bg-grey-700 text-black text-xs font-opensans font-normal leading-4.5 px-5 py-xxxsm h-xxs items-center flex",
        destination && "hover:underline",
      )}
    >
      {destination ? <a href={destination}>{value}</a> : `${value}`}
    </span>
  );
}

export type TagsProps = {
  tagsWrapper?: string;
  tags?: {
    alias?: string;
    name?: string;
  }[];
  refMedium?: string;
};
import { twMerge } from "tailwind-merge";

export const RenderTags = ({ tags, tagsWrapper, refMedium }: TagsProps) => {
  return (
    Array.isArray(tags) && (
      <div
        className={twMerge("flex gap-xxs sm:gap-2 flex-wrap", tagsWrapper)}
        data-testid="tag-wrapper"
      >
        {tags.map(({ alias, name }, index) => (
          <Tags
            key={index}
            destination={alias}
            value={name}
            id={`tag-${index}`}
            refMedium={refMedium}
          />
        ))}
      </div>
    )
  );
};
